import React, { useMemo } from "react";

const dict = {
    en: { pending: "Pending", active: "Active", error: "Error", warning: "Warning", notFound: "Not Found" },
    ru: { pending: "В ожидании", active: "Активен", error: "Ошибка", warning: "Предупреждение", notFound: "Не найдено" },
    ua: { pending: "Очікує", active: "Активний", error: "Помилка", warning: "Попередження", notFound: "Не знайдено" },
};

const statusMap = (t) => ({
    0: { text: t.pending,  style: { backgroundColor: "#d3d3d3", color: "#000" } }, // Pending
    1: { text: t.active,   style: { backgroundColor: "#4CAF50", color: "#fff" } }, // Active
    2: { text: t.error,    style: { backgroundColor: "#f20000", color: "#fff" } }, // Error
    3: { text: t.warning,  style: { backgroundColor: "#ff9a44", color: "#fff" } }, // Warning
    default: { text: t.notFound, style: { backgroundColor: "#d3d3d3", color: "#000" } },
});

const BadgeStatusView = ({ status, lang = "en" }) => {
    const t = useMemo(() => dict[lang?.toLowerCase()] || dict.en, [lang]);
    const map = statusMap(t);
    const { text, style } = map.hasOwnProperty(status) ? map[status] : map.default;

    return (
        <span
            style={{
                padding: "5px 10px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: "bold",
                ...style,
            }}
        >
      {text}
    </span>
    );
};

export default BadgeStatusView;
